import React from "react";

export type QuestionContent = {
  photo: string;
  caption: React.ReactNode;
  correctAnswer: number;
  otherChoices: number[];
};

export const getQuizContent: () => QuestionContent[] = () => [
  {
    photo: require("../assets/images/q1.jpg"),
    caption: (
      <>
        At which Q line stop along Second Avenue will you find Chuck Close's
        portraits of composer Philip Glass, artist Kara Walker, singer Lou Reed
        — along with two selfies?
      </>
    ),
    correctAnswer: 476,
    otherChoices: [475, 223, 58],
  },
  {
    photo: require("../assets/images/q2.jpg"),
    caption: (
      <>
        One of the biggest terminals in terms of size and a hub for both local
        and out-of-town commuters. What station is it?
      </>
    ),
    correctAnswer: 610,
    otherChoices: [318, 628, 617],
  },
  {
    photo: require("../assets/images/q3.jpg"),
    caption: (
      <>
        A ground-level express station on the BMT Brighton line is decorated
        with this mosaic, amongst others, by Deborah Goletz. Fill in the blank
        for the title of the series and the name of the station: “Postcards from
        _____.”
      </>
    ),
    correctAnswer: 54,
    otherChoices: [39, 50, 141],
  },
  {
    photo: require("../assets/images/q4.jpg"),
    caption: (
      <>
        Which subway terminal for several lines counts an aquarium, a beach and
        amusement parks among its neighbors?
      </>
    ),
    correctAnswer: 58,
    otherChoices: [55, 635, 57],
  },
  {
    photo: require("../assets/images/q5.jpg"),
    caption: (
      <>
        Which elevated station along the L line on the border of East New York
        and Brownsville has the No. 3 train pass above it?
      </>
    ),
    correctAnswer: 135,
    otherChoices: [130, 136, 621],
  },
  {
    photo: require("../assets/images/q6.jpg"),
    caption: (
      <>
        What is the only station in the entire system in which one set of tracks
        is outdoors on an elevated structure, while the other tracks appear to
        be underground but are actually at street level?
      </>
    ),
    correctAnswer: 130,
    otherChoices: [461, 617, 619],
  },
  {
    photo: require("../assets/images/q7.jpg"),
    caption: (
      <>
        At which station can riders see “Flying Home: Harlem Heroes and
        Heroines,” a mosaic that features W.E.B. Dubois?
      </>
    ),
    correctAnswer: 439,
    otherChoices: [441, 305, 199],
  },
  {
    photo: require("../assets/images/q8.jpg"),
    caption: (
      <>
        Which Bronx station has this sign that is a relic of the New York
        Central Railroad, a name that went out of use in 1968?
      </>
    ),
    correctAnswer: 603,
    otherChoices: [375, 212, 143],
  },
  {
    photo: require("../assets/images/q9.jpg"),
    caption: (
      <>
        Which Bronx stop has mosaics featuring Sonia Sotomayor, Reggie Jackson,
        Celia Cruz, Tito Puente, Maya Angelou, Gil Scott-Heron and other
        luminaries?
      </>
    ),
    correctAnswer: 218,
    otherChoices: [366, 603, 108],
  },
  {
    photo: require("../assets/images/q10.jpg"),
    caption: (
      <>
        At which Brooklyn station can riders enter through gates in the form of
        bronze honeycombs?
      </>
    ),
    correctAnswer: 59,
    otherChoices: [54, 133, 44],
  },
];
